export const pixelConfigs = [
  { id: '25652549971004796', eventID: 'TEST40644' },
  { id: '623358863398969', eventID: 'TEST66687' },
  { id: '948034513944672', eventID: 'TEST12846' },
  { id: '1347819929711666', eventID: 'TEST85857' },
  { id: '2631280347261069', eventID: 'TEST95039' },
  { id: '510931511442994', eventID: 'TEST52062' },
  { id: '2680022942205542', eventID: 'TEST75919' },
  { id: '1374647784308149', eventID: 'TEST19987' },
  { id: '1373443907584680', eventID: 'TEST12205' },
  { id: '1557957948881128', eventID: 'TEST62175' },
  { id: '1475756013486572', eventID: 'TEST47846' }
]
